import { mainColor, UNIT } from '../../constants/theme';

export const styles = theme => ({
  root: {
    marginTop: UNIT,
    borderColor: mainColor.colorGray,
    border: '1px solid',
    backgroundColor: mainColor.colorWhite,
    borderRadius: UNIT,
    overflow: 'hidden',
    elevation: 1
  },

  card: {
    height: UNIT * 9.375,
    width: UNIT * 11.71875,
    borderRadius: UNIT,
    borderColor: mainColor.colorGray,
    border: '1px solid ',
    display: 'flex',
    zIndex: 0,
    justifyContent: 'center'
  },

  media: {
    width: '100%',
    height: '100%'
  },

  descriptionSection: {
    fontSize: theme.typography.pxToRem(12)
  },
  titleHeading: {
    fontSize: theme.typography.pxToRem(16),
    fontWeight: '600',
    marginTop: '5px',
    marginBottom: '10px'
  },

  progress: {
    margin: UNIT * 5,
    textAlign: 'center',
    color: mainColor.secondaryColor
  },

  icon: {
    fontSize: UNIT * 1.5,
    alignSelf: 'center'
  },

  titleButton: {
    display: 'flex',
    position: 'relative',
    justifyContent: 'space-between'
  },

  modalStyle: {
    display: 'flex',
    flexDirection: 'column',
    padding: UNIT * 0.625,
    justifyContent: 'center',
    alignItems: 'center'
  },

  noImageIcon: {
    width: '50%',
    height: '50%',
    alignSelf: 'center',
    color: 'gray'
  },
  labelStyle: {
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    right: 0,
    bottom: 0
  },
  mediaStyle: { fontSize: UNIT, color: 'gray', fontWeight: 'bold' },
  svg: { padding: UNIT * 0.625 },
  text: {
    fontWeight: 'bold',
    marginRight: 'auto',
    fontSize: UNIT
  }
});
